module.exports = __webpack_public_path__ + "static/media/GoalGraph.7d5fcb90.gif";